import type { ChatRouter } from "replo-publisher/src/trpc/routers/chat";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: chatRouter,
  client: chatClient,
  utils: chatUtils,
  options: chatOptions,
} = createTrpcRouterConfig<ChatRouter>({
  path: "chat",
  queryClient: getNamespacedQueryClient("chat"),
});

export { chatClient, chatRouter, chatUtils, chatOptions };
